import { useCallback } from 'react';

export const useEvents = () => {
    // Map: eventName -> Map(originalHandler -> wrappedHandler)
    const handlerMap = new Map<string, Map<any, any>>();

    const emit = useCallback((name: string, detail?: any) => {
        window.dispatchEvent(new CustomEvent(name, { detail }));
    }, []);

    const subscribe = useCallback((name: string, handler: (data: any) => void) => {
        const wrapped = (e: Event) => handler((
            e as CustomEvent
        ).detail);

        let map = handlerMap.get(name);
        if (!map) {
            map = new Map();
            handlerMap.set(name, map);
        }

        map.set(handler, wrapped);
        window.addEventListener(name, wrapped);

        return () => {
            window.removeEventListener(name, wrapped);
            map!.delete(handler);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const unsubscribe = useCallback((name: string, handler: (data: any) => void) => {
        const map = handlerMap.get(name);
        if (!map) {
            return;
        }

        const wrapped = map.get(handler);
        if (wrapped) {
            window.removeEventListener(name, wrapped);
            map.delete(handler);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return { emit, subscribe, unsubscribe };
};